import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: '[versatileListBodyAfter]'
})
export class VersatileListBodyAfterDirective {
    constructor(public template: TemplateRef<any>) {
    }
}
